import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default function (G6) {
  G6.registerBehavior('dragPoint', {
    getDefaultCfg: function getDefaultCfg() {
      return {
        updateEdge: true,
        delegate: true,
        delegateStyle: {},
        dragEdge: false
      };
    },
    getEvents: function getEvents() {
      return {
        'controlPoint:dragstart': 'onDragStart',
        'controlPoint:drag': 'onDrag',
        'controlPoint:dragend': 'onDragEnd'
      };
    },
    onDragStart: function onDragStart(e) {
      var node = e.target.getParent().getParent().get('item');
      var anchorIndex = e.item.get('index');
      this.target = e.item;
      this.origin = {
        x: e.x,
        y: e.y,
        sourceNode: node,
        sourceAnchor: anchorIndex
      };
      this.graph.set('edgeDragging', true);
    },
    onDrag: function onDrag(e) {
      if (!this.origin) {
        return;
      }
      var node = e.target.getParent().getParent().get('item');
      var anchorIndex = e.item.get('index');
      var model = node.getModel();
      var currentWidth = model.size[0];
      var currentHeight = model.size[1];
      var addWidth = e.x - this.origin.x;
      var addHeight = e.y - this.origin.y;
      var width = currentWidth;
      var height = currentHeight;
      // 0,0 // 两个都是负的变大
      // 1,0 // 一正 一负 变大
      // 1,1 // 两个都是负变大
      // 0,1 // 一负 一正 变大
      var pointIndex = this.origin.sourceAnchor;
      if (pointIndex === 0) {
        width = currentWidth - addWidth;
        height = currentHeight - addHeight;
      } else if (pointIndex === 1) {
        height = currentHeight - addHeight;
      } else if (pointIndex === 2) {
        width = currentWidth + addWidth;
        height = currentHeight - addHeight;
      } else if (pointIndex === 3) {
        width = currentWidth + addWidth;
      } else if (pointIndex === 4) {
        width = currentWidth + addWidth;
        height = currentHeight + addHeight;
      } else if (pointIndex === 5) {
        height = currentHeight + addHeight;
      } else if (pointIndex === 6) {
        width = currentWidth - addWidth;
        height = currentHeight + addHeight;
      } else if (pointIndex === 7) {
        width = currentWidth - addWidth;
      }
      var group = node.getContainer();
      // 移动过程中的控制点全部隐藏。
      group.controlPointShapes.forEach(function (a) {
        return a.hide();
      });
      this.graph.updateItem(node, {
        size: [width, height]
      });
      this.origin = {
        x: e.x,
        y: e.y,
        sourceNode: node,
        sourceAnchor: anchorIndex
      };
    },
    onDragEnd: function onDragEnd(e) {
      if (!this.origin) {
        return;
      }
      var node = e.target.getParent().getParent().get('item');
      this.target = null;
      this.origin = null;
      var group = node.getContainer();
      group.clearControlPoints(group);
      group.showControlPoints(group);
      this.graph.set('edgeDragging', false);
    }
  });
}